import { NotificationService } from './../../../../Services/notification.service';
import { NgFor } from '@angular/common';
import { UserInvestorService } from './../../../../Services/User/Investor/user-investor.service';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UsersearchService } from '../../../../Services/User/UserSearch/usersearch.service';

interface Document {
  doc_user_img?: string;
  doc_pan_front_img?: string;
  doc_pan_back_img?: string;
  doc_aadhar_front_img?: string;
  doc_aadhar_back_img?: string;
  [key: string]: any;
}

interface Investor {
  id: number;
  name: string;
  mobilenumber: string;
  gstnumber: string;
  email: string;
  doc_user_img?: string;
  documents?: Document[];
}

@Component({
  selector: 'app-investor-list',
  standalone: true,
  imports: [NgFor, RouterLink],
  templateUrl: './investor-list.component.html',
  styleUrl: './investor-list.component.css'
})
export class InvestorListComponent implements OnInit {

  userInvestorList: Investor[] = [];
  fullCustomerList: Investor[] = [];

  constructor(
    private userInvestorService: UserInvestorService,
    private notificationService: NotificationService,
    private userSearchService: UsersearchService
  ) { }

  ngOnInit(): void {
    this.userSearchService.searchText$.subscribe(text => {
      this.applySearchFilter(text);
    });

    this.getUserInvestors();
  }

  applySearchFilter(searchText: string) {
    const text = (searchText || '').trim().toLowerCase();
    if (!text) {
      this.userInvestorList = [...this.fullCustomerList];
      return;
    }

    this.userInvestorList = this.fullCustomerList.filter(c =>
      String(c.name ?? '').toLowerCase().includes(text) ||
      String(c.mobilenumber ?? '').toLowerCase().includes(text) ||
      String(c.email ?? '').toLowerCase().includes(text) ||
      String(c.gstnumber ?? '').toLowerCase().includes(text)
    );
  }

  getUserInvestors() {
    this.userInvestorService.getUserInvestor().subscribe({
      next: (res: any) => {
        this.fullCustomerList = res.data || [];
        this.applySearchFilter(this.userSearchService.getSearchText());
        console.log('User Investor List:', this.userInvestorList);
      },
      error: (err: any) => {
        console.error('Error fetching user investor list:', err);
        this.notificationService.showError('Failed to load investor list', 'Error');
      }
    });
  }

  onDelete(id: number) {
    if (confirm('Are you sure you want to delete this investor?')) {
      this.userInvestorService.deleteUserInvestor(id).subscribe({
        next: (res: any) => {
          console.log('User Investor Deleted Successfully:');
          this.notificationService.showSuccess(
            'Investor Deleted Successfully',
            'Success'
          );
          this.getUserInvestors();
        },
        error: (err: any) => {
          console.error('Error deleting user investor:', err);
          this.notificationService.showError('Failed to delete investor', 'Error');
        }
      });
    }
  }
}
